// extracted by css-extract-rspack-plugin
export default {"cls1":"UpsellModalRedesign-cls1_ddZ","cls2":"UpsellModalRedesign-cls2_HEH UpsellModalRedesign-cls1_ddZ"};